// The form editor's loop: touching a control refreshes at once — and the two gestures no longer
// travel the same way.
//
//   A TICK keeps or drops a question. It lives INSIDE the built result, so there is already an
//   address on screen and the reader is asking for the next one: a tick BUILDS, and building is a
//   POST. What comes back is a form, and that form is itself a tool — but it is the ANSWER, so it
//   is fetched like one.
//
//   THE SERVICE LIST names what the address field is cut to. Changing it asks for nothing more than
//   a differently shaped field: it RESHAPES. Nothing is computed, nothing is built, nothing is
//   answered — it is the small form in the hero coming back for more input. So it now travels by
//   GET, carrying what has been typed in the address, exactly like any other prefilled link.
//
// WHAT THAT DELETED. The reshape used to be a POST pretending not to be one, and it needed four
// separate contrivances to keep up the pretence: a hidden submitter built in JavaScript, a
// `formNoValidate` so the errand field would not refuse it, an action stripped of its `#result`
// anchor so it would not land on the answer, a `data-locked` so the required-field guard would not
// shut a button nobody presses — and, on the server, a `reshape=true` flag read for the sole purpose
// of NOT answering. All four are gone. A GET does not validate, does not anchor, is not a
// submission, and cannot build: the platform guarantees it renders a form and never a result.
//
// Progressive: with JavaScript off, the service still travels with the next submission — you lose
// the immediacy, not the function.

/** The three fields the editor's hero form carries, and the only ones a reshape needs to keep. */
const CARRIED = ['intention', 'destination', 'backend'];

function reshape(form) {
	const action = form.getAttribute('action') || window.location.href;
	let target;
	try {
		target = new URL(action, window.location.href);
	} catch (ignored) {
		return; // a malformed action is the server's problem; better to do nothing than to guess
	}
	// No `#result`: a reshape is not an answer, and landing on one would scroll past the very field
	// it just reshaped.
	target.hash = '';
	target.search = '';
	CARRIED.forEach((name) => {
		const field = form.elements[name];
		// `form.elements[name]` yields a list when several controls share a name; a reshape only ever
		// carries single-valued fields, so anything else is left out rather than guessed at.
		const value = field && typeof field.value === 'string' ? field.value.trim() : '';
		if (value) {
			target.searchParams.set(name, value);
		}
	});
	window.location.assign(target.href);
}

document.querySelectorAll('[data-editor-tick], [data-editor-repost]').forEach((control) => {
	const form = control.closest('form');
	if (!form) return;

	control.addEventListener('change', () => {
		if (control.hasAttribute('data-editor-repost')) {
			reshape(form);
			return;
		}
		// A tick builds. requestSubmit, not submit: it runs validation and fires the submit event,
		// where plain submit() bypasses both and would skip every listener bound to the submission —
		// the one that holds the reading position included.
		if (form.requestSubmit) {
			form.requestSubmit();
		} else {
			form.submit();
		}
	});
});
